// Base path constants
export const VERSION: string = "/v1";
export const AUTH: string = "/auth";
export const SUBSCRIPTION: string = "/subscription" + VERSION;
 
// Auth API endpoints
export const authApiEndpoint = {
  ENDPOINT_LOGIN: AUTH + "/login",
  ENDPOINT_SIGNUP: AUTH + "/signup",
  ENDPOINT_RESET_PASSWORD_TOKEN: AUTH + "/reset_password",
  EMAIL_VERIFICATION: AUTH + "/users/verification",
  LOGOUT: AUTH + "/users/logout",
  EVENT_STREAM: AUTH + "/stream/events",
};

// Subscription API endpoints

export const subscriptionApiEndpoint = {
  ENDPOINT_SUBSCRIPTIONS: SUBSCRIPTION + "/subscriptions",
  COMPANY_SUBSCRIPTION: SUBSCRIPTION + "/subscriptions/company-subscriptions",
  COMPANY_SUBSCRIPTION_DETAILS: SUBSCRIPTION + "/subscriptions/companies/me",

  ENDPOINT_REMOVE_PROFILE_IMAGE: SUBSCRIPTION + "/users/logo",
  ENDPOINT_UPLOAD_PROFILE_IMAGE: SUBSCRIPTION + "/users/me/profile-image",
  ENDPOINT_PRODUCTS: SUBSCRIPTION + "/users/products",
  ENDPOINT_VALIDATE_ACTIVATION: SUBSCRIPTION + "/users/activation-validate",
  ENDPOINT_USER: SUBSCRIPTION + "/users/me",
  ENDPOINT_ALL_USER: SUBSCRIPTION + "/users",
  RESEND_USER_INVITATION: SUBSCRIPTION + "/users", 
  ENDPOINT_USER_PREFERENCES: SUBSCRIPTION + "/users/preferences/me",
  ENDPOINT_USER_PREFERENCES_SYSTEM_MODE:SUBSCRIPTION + "/users/preferences/system-modes/me",
  ENDPOINT_UPDATE_PASSWORD: SUBSCRIPTION + "/users/me/password",
  USERS_ONBOARDING: SUBSCRIPTION + "/users/onboarding",
  USER_INVITE: SUBSCRIPTION + "/users/invites",
  ENDPOINT_RESEND_EMAIL: SUBSCRIPTION + "/user/activation/resend",
  ENDPOINT_USER_ACTIVE: VERSION + "/user/activate",

  ENDPOINT_CREATE_COMPANY: SUBSCRIPTION + "/companies",
  ENDPOINT_COMPANY_PREFERENCES_SYSTEM_MODE:SUBSCRIPTION + "/companies/preferences/system-mode/me",
  ENDPOINT_COMPANY_BRANCH: SUBSCRIPTION + "/companies/branches",
  ENDPOINT_COMPANY_DOMAIN: SUBSCRIPTION + "/companies/domains",
  ENDPOINT_COMPANY_DETAILS: SUBSCRIPTION + "/companies/me",
  ENDPOINT_NOTIFICATION_PREFERENCES: SUBSCRIPTION + "/companies/notification-preferences",
  ENDPOINT_COMPANY_PREFERENCES: SUBSCRIPTION + "/companies/preferences/me",
  ENDPOINT_OFFERED_SERVICES: SUBSCRIPTION + "/companies/offered-services",

  ENDPOINT_SUBSCRIPTION_BY_PRODUCT: SUBSCRIPTION + "/company-subscriptions/me/product-types",
  ENDPOINT_CREATE_SUBSCRIPTIONS:SUBSCRIPTION + "/company-subscriptions/me",
  ENDPOINT_SUBSCRIPTION_PRICING_PLANS: SUBSCRIPTION + "/company-subscriptions/me/subscription-pricing-plans/",
  COMPANY_SUBSCRIPTION_PAYMENT:SUBSCRIPTION + "/company-subscriptions/me/payments", 
  CURRENT_COMPANY_SUBSCRIPTION:SUBSCRIPTION+"/company-subscriptions/me/plans",
  

  ENDPOINT_REMOVE_COMPANY_LOGO: SUBSCRIPTION + "/rebrandings/logo",
  ENDPOINT_REBRANDING: SUBSCRIPTION + "/rebrandings/me",
  ENDPOINT_CREATE_REBRANDING: SUBSCRIPTION + "/rebrandings",

  ENDPOINT_LEGAL_DETAILS_FIELD: SUBSCRIPTION + "/legal-details/countries",
  ENDPOINT_COMPANY_LEGAL_DETAILS: SUBSCRIPTION + "/legal-details/companies",
  
  ENDPOINT_USER_ROLE: SUBSCRIPTION + "/user-roles",
  ENDPOINT_ROLE_PRIVILEGE: SUBSCRIPTION + "/user-roles/privileges",


  ENDPOINT_ALL_PRODUCTS: SUBSCRIPTION + "/product-types",
  ENDPOINT_SERVICES: SUBSCRIPTION + "/services",
  

  ENDPOINT_INTEGRATIONS: SUBSCRIPTION + "/integrations",
  ENDPOINT_SLACK_AUTH_URL: SUBSCRIPTION + "/integrations/slack/auth-url",
  ENDPOINT_SLACK_INSTALLATIONS: SUBSCRIPTION + "/integrations/slack/installations",
  ENDPOINT_SLACK_DISCONNECT: SUBSCRIPTION + "/integrations/slack/disconnect",
  ENDPOINT_SLACK_CHANNELS: SUBSCRIPTION + "/integrations/slack/channels",
  ENDPOINT_SLACK_TEST_MESSAGE: SUBSCRIPTION + "/integrations/slack/test-message",

  ENDPOINT_NOTIFICATION_EVENTS: SUBSCRIPTION + "/notification-routings/events",
  ENDPOINT_NOTIFICATION_ROUTES: SUBSCRIPTION + "/notification-routings/routes",
  ENDPOINT_NOTIFICATION_ROUTE_DISABLE: SUBSCRIPTION + "/notification-routings/routes",
};

// common API endpoints
export const commonApiEndpoint = {
  ENDPOINT_COUNTRY: VERSION + "/countries",
  ENDPOINT_STATE: VERSION + "/states",
  ENDPOINT_CITY: VERSION + "/cities",
};
